import frMessages from '../languages/fr/kendoLanguage.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import numbers from 'cldr-numbers-full/main/fr/numbers.json';
import currencies from 'cldr-numbers-full/main/fr/currencies.json';
import caGregorian from '../languages/fr/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/fr/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/fr/timeZoneNames.json';
import { load, loadMessages } from '@progress/kendo-react-intl';
import { GetLanguage } from './language';

export function loadLocalization() {
    //if (GetLanguage() == "fr") {
        loadMessages(frMessages, 'fr');

        load(
            likelySubtags,
            currencyData,
            weekData,
            numbers,
            currencies,
            caGregorian,
            dateFields,
            timeZoneNames
        );
    //}
}